import { BRAND } from '../../../constants'
import { TitleWithHighlight } from '../../UI/index'
import { insertDynamicText } from '../../../controllers/helpers'
import ReactMarkdown from 'react-markdown'
import { useRouter } from 'next/router'
import Post from './Post'
import WrittenBy from './WrittenBy'
import SecondaryHowItWorks from './SecondaryHowItWorks'
import rehypeRaw from 'rehype-raw'
import { addAnchors } from './addAnchors'
import { VeeVenue } from '../../../models/types/VeeVenue.type'
import { VeeListicle } from '../../../models/types/VeeListicle.type'
const { media } = BRAND

export const listicleMarkdownComponents = {
  img: (props: any) => <img {...props} style={{ maxWidth: '100%', borderRadius: '8px' }} />,
  li: (props: any) => (
    <li
      {...props}
      style={{ color: '#4a4c49', fontSize: '16px', lineHeight: 1.7, fontWeight: 500, textAlign: 'left' }}
    />
  ),
  a: (props: any) => <a {...props} style={{ color: '#AF231C' }} />
}

type ListicleProps = {
  listicle: VeeListicle
  howItWorks: any
  displayLocation: string
  nicheOrEventName: string
  callToActionURL: string
  locale: string
  baseUrl: string
}

export const Listicle = ({
  listicle,
  howItWorks,
  displayLocation,
  nicheOrEventName,
  callToActionURL,
  locale,
  baseUrl
}: ListicleProps) => {
  const { query } = useRouter()

  let { created_at, updated_at, title, introduction, venues, author, isBlogArticle } = listicle || {}
  title = insertDynamicText(title, displayLocation, nicheOrEventName)
  const listicleDate = updated_at || created_at

  if (query.page && typeof query.page == 'number' && query.page > 1) {
    return null
  }

  const introductions = introduction.split(/\n(?!(\s*-|\s*\d+\.))/g).filter((e) => e)

  return (
    <section className={`margin ${isBlogArticle ? 'blog-article' : ''}`}>
      {author.length > 0 && (
        <WrittenBy author={author} locale={locale} listicleDate={listicleDate} baseUrl={baseUrl} />
      )}
      <br />
      <div>
        <TitleWithHighlight h2 string={title} highlight={{ displayLocation, nicheOrEventName }} />
      </div>

      <section className='standfirst'>
        {introductions.map((string: string, index: number) => (
          <div key={`section-${string}-${index}`}>
            <ReactMarkdown
              components={listicleMarkdownComponents}
              className='markdown'
              rehypePlugins={[rehypeRaw, addAnchors]}>
              {string}
            </ReactMarkdown>
            <br />
          </div>
        ))}
      </section>
      {!listicle.isBlogArticle && (
        <SecondaryHowItWorks howItWorks={howItWorks} callToActionURL={callToActionURL} />
      )}
      {venues.map((venue: VeeVenue, index: number) => (
        <Post
          key={venue.id}
          venue={venue}
          postIndex={index}
          callToActionURL={callToActionURL}
          locale={locale}
          isBlogArticle={listicle.isBlogArticle}
        />
      ))}
      <style jsx>{`
        .blog-article p,
        .blog-article .standfirst {
          text-align: left;
        }

        .blog-article p:has(img) {
          text-align: center;
        }

        .blog-article img {
          max-height: 30em;
        }

        .markdown h1::before,
        .markdown h2::before,
        .markdown h3::before,
        .markdown h4::before {
          /* Required to ensure anchor links use the correct vertical position */
          content: '';
          display: block;
          height: 75px;
          margin-top: -75px;
          visiblity: hidden;
        }

        .location {
          margin: 12px 0px;
        }
        .row {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 100%;
          margin: 6px 0px;
        }

        .margin {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 16px 36px 16px;
          width: 100%;
        }

        .standfirst {
          font-weight: 200;
          font-size: 22px;
          max-width: 800px;
          text-align: center;
          margin: 8px 0px;
        }
        @media screen and (max-width: ${media.average}px) {
        }
        @media screen and (max-width: ${BRAND.media.tablet}px) {
          .reduce-margin {
            margin: -20px 0px;
          }
        }
      `}</style>
    </section>
  )
}
